import { createFileRoute } from '@tanstack/react-router'
import { Waypoints } from 'lucide-react'
import { z } from 'zod'
import { TracesScreen } from '@/screens/investigate/SCR-019-traces'

export const Route = createFileRoute('/_app/w/$ws/traces')({
  staticData: { screen: { id: 'SCR-019', title: 'Trace explorer', group: 'Investigate', perm: 'trace.read', order: 3, description: 'Follow requests through capture, retrieval, packing, delivery and outcome.', icon: Waypoints } },
  validateSearch: z.object({
    q: z.string().max(200).optional(),
    outcome: z.enum(['up', 'down', 'none']).optional().catch(undefined),
    problem: z.enum(['degraded', 'semantic_failed']).optional().catch(undefined),
    simulated: z.enum(['exclude', 'include', 'only']).optional().catch(undefined),
  }),
  component: TracesScreen,
})
